module.exports = __webpack_public_path__ + "img/bg_top_account_index_blue.51378312.png";